import { Component, effect, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DialogMode } from 'src/app/models/dialog-mode.model';
import { Plan } from 'src/app/models/plan.model';
import { PlanFilterService } from './plan-filter.service';
import { CommonModule } from '@angular/common';
import { PlanGroupComponent } from './plan-group.component';
import { PlansService } from '@/services/api/plans.service';
import { DataViewModule } from 'primeng/dataview';
import { PlanFilterComponent } from './plan-filter.component';
import { OfficesService } from '@/services/api/franchises.service';

@Component({
    selector: 'app-plan-browser',
    imports: [PlanGroupComponent, CommonModule, DataViewModule],
    template: `
  <section class="grid grid-col-12 xl:grid-cols-6 md:grid-cols-6 gap-2">
    <div *ngFor="let group of planFilterService.filteredPlanGroups(); let i = index" 
         
         [ngClass]="{'locked': lockedIndex !== null && lockedIndex !== i}">
      <app-plan-group 
          [group]="group" 
          [locked]="lockedIndex === i" 
          (select)="toggleLock(i)"
          (selectPlan)="onSelectPlan($event)">
      </app-plan-group>
    </div>
  </section>
  `
})
export class PlanBrowserComponent {
  lockedIndex: number | null = null;
 
  constructor(
    public plansService: PlansService,
    public planFilterService: PlanFilterService,
    private officeService: OfficesService
  ) {
   this.plansService.populateAllplans();

  }

  getStyles(plans: Plan[]) {
    return plans.map(plan => plan.Styles?.StyleName).join(', ');
  }

  toggleLock(index: number): void {
    if (this.lockedIndex === index) {
        this.lockedIndex = null; // Unlock if the same item is clicked again
    } else {
        this.lockedIndex = index; // Lock the clicked item
    }
  }

  adjustSelectedPlan(plans: Plan[]) {
    const selected = this.plansService.selectedPlan();
    if(selected) {
      const newPlan = plans.find(plan => plan.PlanID === selected.PlanID);
      if(newPlan) {
        this.plansService.selectedPlan.set(newPlan);
      }
    }
  }

  onSelectPlan(plan: Plan) {
    this.plansService.selectedPlan.set(plan);
    this.planFilterService.setDialogOpen(false);
  }

  onSearch(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const query = inputElement?.value ?? '';
    this.planFilterService.searchPlans(query);
  }

}